export default __webpack_public_path__ + "static/media/wav2vec2.5ced29fc.png";